import { server_connection } from 'config';
import { auth } from 'firebase';
import store from 'store';
import { getContentLabelList } from '../../../content_label/store/actions';

export const GET_MODULE = '[MODULE APP] GET MODULE';
export const GET_MODULE_LIST = '[MODULE APP] GET MODULE LIST';
export const DELETE_MODULE = '[MODULE APP] DELETE MODULE';
export const UPDATE_MODULE_LOADED = '[MODULE APP] UPDATE MODULE LOADED'
export const SAVE_MODULE = '[MODULE APP] SAVE MODULE';
export const UPDATE_MODULE_FORM = '[MODULE APP] UPDATE MODULE FORM';
export const GET_RELATED_DATA = '[MODULE APP] GET RELATED DATA';
export const GET_MODULE_ASSET_LIST = '[MODULE APP] GET MODULE ASSET LIST';
export const LOCK_MODULE = '[MODULE APP] LOCK MODULE';
export const UNLOCK_MODULE = '[MODULE APP] UNLOCK MODULE';
export const UPDATE_MODULE_LIST_LOADED = '[MODULE APP] UPDATE MODULE LIST LOADED';

// MODULE -> Course relation
export const GET_ALL_COURSES = '[MODULE APP] GET ALL COURSES';
export const TOGGLE_COURSE = '[MODULE APP] TOGGLE COURSE';

// MODUE -> Lesson relation
export const GET_ALL_LESSONS = '[MODULE APP] GET ALL LESSONS';
export const TOGGLE_LESSON = '[MODULE APP] TOGGLE LESSON';

//SCHEDULE
export const LOWER_WEEK_DELETE_CHECK = '[MODULE APP] LOWER WEEK DELETE CHECK';
export const CHANGE_SCHEDULE_WEEKS_NEEDED = '[MODULE APP] CHANGE SCHEDULE DAYS NEEDED';
export const DROP_ITEM_TO_DAY = '[MODULE APP] DROP ITEM TO DAY';
export const REMOVE_MODULE_LESSON_RELATION = '[MODULE APP] REMOVE MODULE LESSON RELATION';
export const SAVE_SCHEDULE = '[MODULE APP] SAVE SCHEDULE';
export const GET_SCHEDULED_LESSONS = '[MODULE APP] GET SCHEDULED LESSONS';

export const TOGGLE_COMPANY = '[MODULE APP] TOGGLE COMPANY';
export const COMPANY_UPDATE_SEARCH = '[MODULE APP] COMPANY UPDATE SEARCH';
export const GET_COMPANY_LIST = '[MODULE APP] GET COMPANY LIST';
export const ACTIVATE_MODULE = '[MODULE APP] ACTIVATE MODULE';
export const UPDATE_ASSET_NAME = '[MAJOR APP] UPDATE ASSET NAME';

export function updateModuleLoaded(setting) {
    return {
        type: UPDATE_MODULE_LOADED,
        payload: setting
    }
}

export function updateModuleListLoaded(setting) {
    return {
        type: UPDATE_MODULE_LIST_LOADED,
        payload: setting
    }
}

export function updateModuleForm(module_data) {
    return {
        type: UPDATE_MODULE_FORM,
        payload: module_data
    }
}

export function getModuleData(module_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getModule(module_id)),
            dispatch(getAllCourses()),
            dispatch(getAllLessons()),
            dispatch(getRelatedData(module_id)),
            dispatch(getScheduledLessons(module_id)),
            dispatch(getModuleAssetList(module_id)),
            dispatch(getContentLabelList())
        ]).then(
            () => dispatch(updateModuleLoaded(true))
        )
    }
}

export function getModule(module_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/module/get/' + module_id)
            .then((response) => response.json())
            .then((moduleData) => {
                dispatch({
                    type: GET_MODULE,
                    payload: moduleData,
                });
            });
    }
}

export function getCompanyList() {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/list')
            .then((response) => response.json())
            .then((companyList) => {
                dispatch({
                    type: GET_COMPANY_LIST,
                    payload: companyList,
                });
            });
    }
}

export function getModuleAssetList(module_id, assetInsertResponse = []) {
    return (dispatch) => {
        fetch(server_connection + '/module/asset_list/' + module_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_MODULE_ASSET_LIST,
                    payload: { responseData, assetInsertResponse }
                });
            });
    }
}

export function saveModule(module, lesson_list, auth_id, companies) {
    const newModule = { ...module, CreateAuthID: auth_id, LastEditAuthID: auth_id, companies }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    module: newModule,
                    lesson_list: lesson_list,
                    companies
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getModuleList('actions'));
            })
    }
}

export function deleteModule(module_id) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/module/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ module_id: module_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_MODULE,
                    payload: module_id,
                });
            });
    }
}

export function getModuleList(call_location) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/list/' + auth_id)
            .then((response) => response.json())
            .then((moduleList) => {
                dispatch({
                    type: GET_MODULE_LIST,
                    payload: { moduleList, call_location },
                });
            });
    }
}

// RELATIONAL DATA

function getRelatedData(module_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/data/' + module_id)
            .then((response) => response.json())
            .then((relatedData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: relatedData
                })
            })
    }
}

function getAllCourses() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/course/list/' + auth_id)
            .then((response) => response.json())
            .then((allCourses) => {
                return dispatch({
                    type: GET_ALL_COURSES,
                    payload: allCourses
                })
            })
    }
}

export function toggleCourse(course, action_type) {
    return {
        type: TOGGLE_COURSE,
        payload: { course: course, action_type: action_type }
    }
}


export function getAllLessons() {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch) => {
        return fetch(server_connection + '/lesson/list/' + auth_id)
            .then((response) => response.json())
            .then((allLessons) => {
                return dispatch({
                    type: GET_ALL_LESSONS,
                    payload: allLessons
                })
            })
    }
}

function getScheduledLessons(module_id) {
    return (dispatch) => {
        return fetch(server_connection + '/module/get_lessons/' + module_id)
            .then((response) => response.json())
            .then((scheduledLessons) => {
                return dispatch({
                    type: GET_SCHEDULED_LESSONS,
                    payload: scheduledLessons
                })
            })
    }
}

export function toggleLesson(lesson, action_type) {
    return {
        type: TOGGLE_LESSON,
        payload: { lesson: lesson, action_type: action_type }
    }
}

export function lowerWeekDeleteCheck() {
    return {
        type: LOWER_WEEK_DELETE_CHECK,
        payload: null
    }
}

export function changeScheduleWeeksNeeded(setting) {
    return {
        type: CHANGE_SCHEDULE_WEEKS_NEEDED,
        payload: setting
    }
}

export function dropItemToDay(lesson, week, day, module_id, dayValue) {
    return {
        type: DROP_ITEM_TO_DAY,
        payload: {
            lesson: lesson,
            week: week,
            day: day,
            module_id: module_id,
            dayValue: dayValue
        }
    }
}

export function removeModuleLessonReleation(lesson_id) {
    return {
        type: REMOVE_MODULE_LESSON_RELATION,
        payload: lesson_id
    }
}

export function companyUpdateSearch(characters) {
    return {
        type: COMPANY_UPDATE_SEARCH,
        payload: characters
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: { company, action_type }
    }
}

export function saveSchedule(module_id, lessons) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/save/schedule',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    module_id: module_id,
                    lessons: lessons,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getModuleList('actions'));
            })
    }
}

export function lockModule(module_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/lock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ module_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: LOCK_MODULE,
                    payload: auth_id
                });
            });
    }
}

export function unlockModule(module_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/unlock',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ module_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: UNLOCK_MODULE,
                    payload: true,
                });
            });
    }
}

export function activateModule(module_id, auth_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/module/activate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ module_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: ACTIVATE_MODULE,
                    payload: true,
                });
            });
    }
}
export function updateAssetName(newName, asset_id, saved) {
    return {
        type: UPDATE_ASSET_NAME,
        payload: { newName, asset_id, saved }
    }
}


// WEBPACK FOOTER //
// src/main/content/module/store/actions/module.actions.js